import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab, Typography, Grid } from '@mui/material';
import { Work } from '@mui/icons-material';
import CombinedStipendReport from './CombinedStipendReport';
import StipendUploadFile from './StipendUploadFile';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`stipend-tabpanel-${index}`}
      aria-labelledby={`stipend-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            pt: 1,
            pb: 1,
            animation: 'fadeIn 0.3s ease-in',
            '@keyframes fadeIn': {
              from: { opacity: 0, transform: 'translateY(10px)' },
              to: { opacity: 1, transform: 'translateY(0)' },
            },
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

function StipendReport() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '10px', padding: '5px' }}>
      <Paper elevation={5} sx={{ width: '100%', maxWidth: '1200px' }}>
        <Grid className="form-title" container spacing={2}>
          <Grid item>
            <Typography
              variant="h4"
              sx={{ textAlign: 'center', margin: 3, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <Work sx={{ fontSize: 40 }} />
              Stipend Report
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ margin: '10px', marginTop: '0px' }}>
          <Box
            sx={{
              width: '100%',
              background: '#ffffff',
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            }}
          >
            <Box
              sx={{
                borderBottom: 2,
                borderColor: 'divider',
                background: '#f8f9fa',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="stipend report tabs"
                centered
                sx={{
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.9rem',
                    minHeight: 50,
                    px: 3,
                    color: '#6c757d',
                    '&:hover': {
                      color: '#0b418e',
                      background: 'rgba(102, 126, 234, 0.08)',
                    },
                    '&.Mui-selected': {
                      color: '#0b418e',
                      fontWeight: 700,
                    },
                  },
                  '& .MuiTabs-indicator': {
                    height: 3,
                    borderRadius: '3px 3px 0 0',
                    background: 'linear-gradient(90deg, #0b418e 0%, #083a6d 100%)',
                  },
                }}
              >
                <Tab label="Combined Stipend Report" />
                <Tab label="Stipend Upload File" />
              </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
              <CombinedStipendReport isEmbedded={true} />
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <StipendUploadFile isEmbedded={true} />
            </TabPanel>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

export default StipendReport;

